module.exports = "<svg viewBox=\"0 0 560 560\" xmlns=\"http://www.w3.org/2000/svg\"><title>chevron_up</title><path d=\"M304.813 174.313c-13.687-13.75-35.94-13.75-49.626 0L50.205 380.245c-13.647 13.71-13.6 35.892.103 49.545 13.704 13.653 35.876 13.607 49.523-.103l180.176-181.01 180.163 181.01c13.646 13.71 35.818 13.756 49.522.103s13.75-35.835.103-49.545\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./src/icons/chevron_up.svg
// module id = 559
// module chunks = 0 1 2